/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../../types/schema.generated';

import gql from 'graphql-tag';
import { AdminNewsListItemNewsForPlannerFragmentDoc } from './AdminNewsListItem.generated';
export type AdminNewsListNewsForPlannerFragment = { id: string, title: string, body: string, publishedAt: TimeString };

export const AdminNewsListNewsForPlannerFragmentDoc = gql`
    fragment AdminNewsListNewsForPlanner on NewsForPlanner {
  id
  ...AdminNewsListItemNewsForPlanner
}
    ${AdminNewsListItemNewsForPlannerFragmentDoc}`;